import React from 'react';
import { CopyMagicPropsInterface } from '../CopyMagic.types';
import { GENERATOR_NAMES } from '../constants';

/*
ConfigContext
  Stores props provided to the <CopyMagic /> entrypoint component
  This context does not pass props along to children, it is designed to
  extract props out and into a React context for access by all child components
  of the provider
*/
const noop = () => {};
const DEFAULTS = {
  generatorName: GENERATOR_NAMES.COURSE_OUTLINE,
  trigger: <button type="button" />,
  onApply: noop,
  onDiscard: noop,
  onOpen: noop,
  productEvents: {
    suffix: '',
    payload: {},
  },
  initialPrompt: '',
  scopedClassName: '',
  aiConsentRequired: true,
  fullscreen: false,
  contextToken: '',
  suggestions: [],
} as const;

export const ConfigContext = React.createContext<Required<CopyMagicPropsInterface>>(DEFAULTS);

export const useConfigContext = () => {
  const context = React.useContext(ConfigContext);
  if (!context) throw new Error(`outside of provider`);
  return context;
};

export const ConfigProvider = ({
  children,
  copyMagicProps,
}: {
  children: React.ReactElement;
  copyMagicProps: CopyMagicPropsInterface;
}) => {
  const providerValue = Object.assign({}, DEFAULTS, copyMagicProps);
  return <ConfigContext.Provider value={providerValue}>{children}</ConfigContext.Provider>;
};
